
export default {
  search: "Search",
  searchPlaceholder: "Search products...",
  scanProduct: "Scan Product",
  scanInstructions: "Take a photo or upload an image of the product to scan",
  useCamera: "Use Camera",
  capture: "Capture",
  matchingProducts: "Matching Products",
  noMatch: "No matching products found",
  noMatchDescription: "We couldn't find any products matching your scan. Would you like to search manually or add a new product?",
  searchManually: "Search Manually",
  addNewProduct: "Add New Product",
  detectedText: "Detected Text",
  detectedInfo: "Detected Product Information",
  name: "Name",
  brand: "Brand",
  description: "Description",
  volume: "Volume",
  ingredients: "Ingredients",
  price: "Price",
  rating: "Rating",
  review: "Review",
  reviews: "Reviews",
  purchaseLocation: "Purchase Location",
  shareExperience: "Share your experience with this product",
  whereBought: "Where did you buy this product?",
  createProduct: "Create Product",
  productCreated: "Product Created",
  productCreatedSuccess: "Your product has been created successfully",
  noResults: "No results found for '{{query}}'",
  searchResults: "Search Results",
  allProducts: "All Products",
  addDirectly: "Add Product Directly",
  chooseImage: "Choose Image",
  noScansYet: "No scan history yet",
  recentScans: "Recent Scans",
  scanAgain: "Scan Again",
  viewProduct: "View Product",
  addProduct: "Add Product",
  weFoundText: "We've detected some text on your product. You can create a new product with this information.",
  textDetected: "Text Detected",
  noProductFound: "No product found. You can add it to our database.",
  productFound: "Product found in our database!",
  scanComplete: "Scan Complete"
};
